<template>
  <transition name="picker-fade">
    <div class="picker" v-show="state===1" @touchmove.prevent @click="cancel">
      <transition name="picker-move">
        <div class="picker-panel" v-show="state===1" @click.stop>
          <div class="picker-content">
            <div class="picker-item" v-for="item in types" :key="item.value" @click="handleChoose(item.value)">
              <div class="picker-item-name">{{ item.label }}</div>
              <div v-if="isChoose(item.value)" class="icon"></div>
            </div>
          </div>
          <div class="interval-line"></div>
          <div class="picker-footer" @click="cancel">取消</div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
const STATE_HIDE = 0;
const STATE_SHOW = 1;
const COMPANY = 'company';
const PERSON = 'person';
const COMPONENT_NAME = 'CustomerTypePicker';
export default _extend({
  name: COMPONENT_NAME,
  props: {
    value: {
      type: String,
      default: COMPANY
    }
  },
  data() {
    return {
      types: [
        {
          label: '公司名称',
          value: COMPANY
        },
        {
          label: '个体名称',
          value: PERSON
        }
      ],
      state: STATE_HIDE,
    };
  },
  created() {
  },
  computed: {
  },
  methods: {
    isChoose(type) {
      if (type === this.value) {
        return {active: true};
      }
    },
    handleChoose(type) {
      this.$emit('select', type);
      this.hide();
    },
    cancel() {
      this.hide();
    },
    show() {
      if (this.state === STATE_SHOW) {
        return;
      }
      this.state = STATE_SHOW;
    },
    hide() {
      this.state = STATE_HIDE;
    },
  },
  watch: {
  }
});
</script>

<style lang="scss" scoped>
@import './CustomerTypePicker.scss';
</style>



// WEBPACK FOOTER //
// src/components/CustomerTypePicker/CustomerTypePicker.vue